import { forwardRef } from 'react';

import { IconButton } from '@/components/form/baseInputs/Button/IconButton';
import { XCloseIcon } from '@/components/icons/XCloseIcon';

export const TypeaheadClearButton = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(function TypeaheadClearButton(
  { children: _children, 'aria-label': ariaLabel = 'Clear', ...buttonProps },
  ref
) {
  return (
    <IconButton
      {...buttonProps}
      ref={ref}
      ariaLabel={ariaLabel}
      icon={XCloseIcon}
      size="xs"
      variant="transparent"
    />
  );
});
